import styles from "./style.module.scss";
import balance from "./slider/img/balance.png";
import tightness from "./slider/img/tightness.png";
import stubborn from "./slider/img/stubborn.png";


import walkyEnergy from "./slider/img/img1.png";
import walkyPosture from "./slider/img/img2.png";
import walkyBalance from "./slider/img/img3.png";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const SLIDER_CONTENT = {
  easyfit: [
    {
      image: stubborn,
      title: "Lose stubborn fat",
      text: "Stress, worry and emotional burdens can sabotage weight loss efforts. This plan provides you with a well-rounded approach to relieve stored emotions and finally get your dream body.",
    },
    {
      image: balance,
      title: "Restore emotional balance",
      text: "Try out our transformative workout exercises to find inner peace, and let go of overwhelming stress, worry, and emotional weight.",
    },
    {
      image: tightness,
      title: "Reduce muscle tightness",
      text: "Use simple poses and stretches to alleviate tension in your muscles, including the hips, back, neck, shoulders, and more.",
    },
  ],

  walky: [
    {
      image: walkyEnergy,
      title: "Boosting heart health",
      text: "Brisk walking gets your heart pumping, improves circulation, and strengthens your cardiovascular system — lowering your risk of heart disease and high blood pressure.",
    },
    {
      image: walkyBalance,
      title: "Enhancing mood and focus",
      text: "When the terrain changes (stairs, bumps, rocks), your body constantly adjusts, training your vestibular system and reducing the risk of falls in the future.",
    },
    {
      image: walkyPosture,
      title: "Supporting weight loss",
      text: "Regular walking burns calories, boosts metabolism, and helps regulate appetite — making it easier to maintain a healthy weight without intense workouts.",
    },
  ],
};

export const WorkoutsSlider = ({ isWalky }) => {
  const slides = isWalky ? SLIDER_CONTENT.walky : SLIDER_CONTENT.easyfit;

  return (
    <div className={styles.workouts}>
      <h2>Workouts that really work</h2>
      <div className={styles.cards}>
        {slides.map((slide, index) => (
          <div className={styles.card} key={index}>
            <div className={styles.cardImage}>
              <img src={slide.image} alt={slide.title} />
              <div className={styles.titleBlock}>{slide.title}</div>
            </div>
            <div className={styles.description}>
              <p>{slide.text}</p>
            </div>
          </div>
        ))}
      </div>

      <p className={styles.disclaimer}>
        *Disclaimer: In order to achieve the best possible results, it's crucial
        to consistently exercise and follow a balanced diet. We encourage you to
        consult with a healthcare professional before starting any exercise
        program.
      </p>
    </div>
  );
};
